export default __webpack_public_path__ + "static/media/mission.f07bfd93.png";